import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  fragment User on User {\n    id\n    email\n    firstName\n    lastName\n    isStaff\n    defaultShippingAddress {\n      ...Address\n    }\n    defaultBillingAddress {\n      ...Address\n    }\n    addresses {\n      ...Address\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import gql from "graphql-tag";
import { checkoutAddressFragment } from "./checkout";
export var userFragment = gql(_templateObject(), checkoutAddressFragment);